// @ts-nocheck
import React from 'react';

// import { Helmet } from 'react-helmet';
// import ContactFormView from '../ContactFormView';
// import styles from './index.module.scss';

export default function FooterWebex() {
  return (
    <footer className="footer_module__21ya7 wx-wrapper navigation-wrapper module" data-module="footer">
      <div className="bg-black color-white">
        <div className="footer_prefooter__3edCk" style={{ backgroundImage: `url(/webex/images/footerBg.png)` }}>
          <div className="container">
            <div className="grid">
              <div className="col">
                <a href="/" className="footer_logo__3rrSz">
                  <img src="/webex/images/webexLogo.png" alt="Webex logo" />
                </a>
              </div>
            </div>
            <div className="grid grid-between">
              <div className="col col-7 col-sm">
                <div className="h2 fw-medium">Get started for free.</div>
              </div>
              <div className="col col-4 col-align-bottom col-sm">
                <div className="lbody fw-regular footer_sideText__3VaMw ">
                  Additional features, storage, and support start at just one low price.
                </div>
              </div>
              <div className="col col-12 col-sm footer_buttonWrapper__28ZDj">
                <a
                  href="https://cart.webex.com/sign-up?experienceType=Unified&ft=selfsignup&theme=dark&ft=skipProvCheck"
                  target="_blank"
                  className="footer_btn__eNunV btn btn-primary"
                >
                  Start for Free
                </a>
                <a href="https://www.webex.com/pricing/index.html" className="btn btn-secondary-light">
                  See Plans &amp; Pricing
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="grid footer_footerWrapper__2p9Tg">
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Small Business
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a href="https://www.webex.com/pricing/index.html" target="_blank" className="sbody">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/all-new-webex.html" target="_blank">
                    Webex App
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/video-conferencing.html" target="_blank">
                    Meetings
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/cloud-calling.html" target="_blank">
                    Calling
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/team-collaboration.html" target="_blank">
                    Messaging
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/screen-sharing.html" target="_blank">
                    Screen Sharing
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Enterprise
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a href="https://www.webex.com/collaboration-suite.html" target="_blank">
                    Webex Suite
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/enterprise-cloud-calling.html" target="_blank">
                    Calling
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/meetings.html" target="_blank">
                    Meetings
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/team-collaboration.html" target="_blank">
                    Messaging
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/audience-engagement.html" target="_blank">
                    Polling
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/webinar.html" target="_blank">
                    Events
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/contact-center.html" target="_blank">
                    Contact Center
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/experience-management.html" target="_blank">
                    Experience Management
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/customer-interaction-management.html" target="_blank">
                    imimobile
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/security.html" target="_blank">
                    Security
                  </a>
                </li>
                <li>
                  <a href="/control-hub.html" target="_blank">
                    Control Hub
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Devices
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a href="https://hardware.webex.com/products/headsets">Headsets</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/cameras">Cameras</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/desk-series">Desk Series</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/room-series-and-kits">Room Series</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/board-series">Board Series</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/phones">Phone Series</a>
                </li>
                <li>
                  <a href="https://hardware.webex.com/products/accessories">Accessories</a>
                </li>
              </ul>
            </div>
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Solutions For
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a href="https://www.webex.com/industries/education.html" target="_blank">
                    Education
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/industries/healthcare.html" target="_blank">
                    Healthcare
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/industries/financial-services.html" target="_blank">
                    Financial Services
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/industries/government.html" target="_blank">
                    Government
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/industries/start-ups.html" target="_blank">
                    Startups
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/industries/sports-entertainment.html" target="_blank">
                    Sports &amp; Entertainment
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/hybrid-work.html'" target="_blank">
                    Hybrid Work
                  </a>
                </li>
                <li>
                  <a href="https://futureofwork.webex.com/" target="_blank">
                    Future of Work
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Resources
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a href="https://www.webex.com/downloads.html" target="_blank">
                    Downloads
                  </a>
                </li>
                <li>
                  <a href="https://help.webex.com" target="_blank">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/test-meeting.html" target="_blank">
                    Join a Test Meeting
                  </a>
                </li>
                <li>
                  <a href="https://help.webex.com/landing/onlineclassNamees" target="_blank">
                    Online classNamees
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/products/integrations/index.html" target="_blank">
                    Integrations
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/accessibility.html" target="_blank">
                    Accessibility
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/inclusive-collaboration.html" target="_blank">
                    Inclusivity
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/learn/webinars-demos.html" target="_blank">
                    Webinars, Events &amp; Demos
                  </a>
                </li>
                <li>
                  <a href="http://cs.co/webexcommunity" target="_blank">
                    Webex Community
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-sm">
              <h6 className="h6 color-white mbody fw-bold footer_collapsible__3jkQc" role="heading">
                Company
              </h6>
              <ul className="sbody footer_menu__34rB4">
                <li>
                  <a
                    href="https://www.cisco.com/c/en/us/solutions/collaboration/index.html#~stickynav=1"
                    target="_blank"
                  >
                    Cisco
                  </a>
                </li>
                <li>
                  <a href="https://help.webex.com/contact/" target="_blank">
                    Contact Support
                  </a>
                </li>
                <li>
                  <a href="https://www.webex.com/contact-sales.html" target="_blank">
                    Contact Sales
                  </a>
                </li>
                <li>
                  <a
                    href="https://webex-promo.cisco.com/customer/account/login/referer/aHR0cHM6Ly93ZWJleC1wcm9tby5jaXNjby5jb20v/isForce/1/check/1/"
                    target="_blank"
                  >
                    Webex Merch Store
                  </a>
                </li>
                <li>
                  <a href="http://cs.co/collaborationjobs" target="_blank">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="https://blog.webex.com/" target="_blank">
                    Webex Blog
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="grid footer_postFooter__GEZvn">
            <div className="col col-4 col-sm footer_social__2mmJW">
              <div className="footer_socialIconWrapper__3eyHO">
                <ul>
                  <li>
                    <a href="https://twitter.com/webex" target="_blank">
                      <span className="icon-twitter"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/webex" target="_blank">
                      <span className="icon-linkedin"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/webex" target="_blank">
                      <span className="icon-facebook"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/c/webex" target="_blank">
                      <span className="icon-youtube"></span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/webex/" target="_blank">
                      <span className="icon-instagram"></span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="xsbody  footer_copyright__2fzys">
                &copy; <span id="this_year">2021</span> Cisco and/or its affiliates. All Rights Reserved.
              </div>
            </div>
            <div className="col col-6 col-sm footer_terms__17opd">
              <ul className="xsbody">
                <li>
                  <a target="_blank" href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html">
                    Terms &amp; Conditions
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html">
                    Privacy Statement
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies">
                    Cookies
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://www.cisco.com/web/siteassets/legal/trademark.html">
                    Trademarks
                  </a>
                </li>
              </ul>
            </div>
            <div className="col col-2 col-sm footer_countrySelector__1ZD90">
              <div className="footer_languageOverlay__3tTZa"></div>
              <div className="footer_language__3GeJS color-black">
                <div className="footer_languageHeader__1iHeI">
                  <span className="mbody">Select Country</span>
                  <span className="close">
                    <span className="icon-close"></span>
                  </span>
                </div>
                <div className="footer_languageWrapper__1qiJ4">
                  <ul className="footer_languageList__gyLHu wf-region-list region-select-list">
                    <li data-id="AU">
                      <a href="https://www.webex.com">Australia (English)</a>
                    </li>

                    <li data-id="BR">
                      <a href="https://www.webex.com/pt/index.html">Brazil (Português)</a>
                    </li>

                    <li data-id="CA">
                      <a href="https://www.webex.com">Canada (English)</a>
                    </li>

                    <li data-id="CAF">
                      <a href="https://www.webex.com/fr/index.html">Canada (Français)</a>
                    </li>

                    <li data-id1="CN">
                      <a href="https://www.webex.com.cn/">China (简体字)</a>
                    </li>

                    <li data-id="FR">
                      <a href="https://www.webex.com/fr/index.html">France (Français)</a>
                    </li>

                    <li data-id="DE">
                      <a href="https://www.webex.com/de/index.html">Germany (Deutsch)</a>
                    </li>

                    <li data-id="HK">
                      <a href="https://www.webex.com/zh-tw/index.html">Hong Kong (繁體中文)</a>
                    </li>

                    <li data-id="IN">
                      <a href="https://www.webex.com">India (English)</a>
                    </li>

                    <li data-id="IT">
                      <a href="https://www.webex.com/it/index.html">Italy (Italiano)</a>
                    </li>

                    <li data-id="JP">
                      <a href="https://www.webex.com/ja/index.html">Japan (日本語)</a>
                    </li>

                    <li data-id="KR">
                      <a href="https://www.webex.com/ko/index.html">South Korea (한국어)</a>
                    </li>

                    <li data-id="MX">
                      <a href="https://www.webex.com/es/index.html">Latin America (Español)</a>
                    </li>

                    <li data-id="ES">
                      <a href="https://www.webex.com/es/index.html">Spain (Español)</a>
                    </li>

                    <li data-id="GB">
                      <a href="https://www.webex.com/">United Kingdom (English)</a>
                    </li>

                    <li data-id="US">
                      <a href="https://www.webex.com/">United States (English)</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer_languageSelect__a_We0">
                <a>
                  <span className="icon-global"></span>
                  <span className="footer_country__2f7Cu wbx-region-name">United States </span>
                  <span>
                    <i className="icon-open"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
